export class SessionTO {
    auth: boolean;
    username: string;
    message: string;
}